import styles from './baroqueSeparator.module.css';
import baroqueSeparator from '../../img/baroque_separator.svg';

const BaroqueSeparator = () => {
    return (
        <img src={baroqueSeparator} className={styles.separator} alt="Trennendes dekoratives Element" />
    );
}

export default BaroqueSeparator;